import React from "react";
import { View } from "native-base";

import { AutoHeighImage } from "../../Image/AutoWidthImage";

type ExpandedImageSlideProps = {
  uri?: string;
  index: number;
  pageWidth: number;
  pageHeight: number;
  scaleAll: number;
  slideInnerStyle: any;
  emptySlideStyle: any;
  onMeasure: (index: number, x: number, width: number) => void;
};

const ExpandedImageSlide: React.FC<ExpandedImageSlideProps> = ({
  uri,
  index,
  pageWidth,
  pageHeight,
  scaleAll,
  slideInnerStyle,
  emptySlideStyle,
  onMeasure,
}) => {
  if (!uri) {
    return <View style={emptySlideStyle} />;
  }

  return (
    <View style={slideInnerStyle}>
      <View
        onLayout={(e) => {
          const { x, width } = e.nativeEvent.layout;
          onMeasure(index, x, width);
        }}
        style={{ alignSelf: "center" }}
      >
        <AutoHeighImage
          width={pageWidth * 0.95}
          scaleAll={scaleAll}
          source={{ uri }}
          maxHeight={pageHeight * 0.7}
        />
      </View>
    </View>
  );
};

export default React.memo(ExpandedImageSlide);
